import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RootLayout from './app/layout';
import HomePage from './app/page';
import CustomerRoulette from './app/web/customer/page';
import PaymentPage from './app/payment/page';
import PaymentProductDetailPage from './app/payment/detail-page';
import TestPaymentPage from './app/test/page';
import TestProductDetailPage from './app/test/detail-page';
import QrPage from './app/qr/page';
import TermsPage from './app/terms/page';

function DemoVideoRedirect() {
    useEffect(() => {
        window.location.replace('https://youtube.com/shorts/FEE2fs-bI9Y?si=rK3pYHiscVwaNu6Q');
    }, []);

    return null;
}

export default function App() {
    return (
        <BrowserRouter>
            <RootLayout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/demovideo" element={<DemoVideoRedirect />} />
                    <Route path="/web/customer" element={<CustomerRoulette />} />
                    <Route path="/payment" element={<PaymentPage />} />
                    <Route path="/payment/:productKey" element={<PaymentProductDetailPage />} />
                    <Route path="/test" element={<TestPaymentPage />} />
                    <Route path="/test/:productKey" element={<TestProductDetailPage />} />
                    <Route path="/qr" element={<QrPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                </Routes>
            </RootLayout>
        </BrowserRouter>
    );
}
